export default __webpack_public_path__ + "locales/zh-CN/DataReassignmentDialog.json?hash=6c385d4327c18c824a8c1b6a57143f32";